module.exports = __webpack_public_path__ + "static/media/magic_2_looped.bc63823d.svg";